import httpClient from "Api/httpClient";

const END_POINT = "/payment_terms";

const getPaymentTerms = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getPaymentTerm = (payment_term_id) => {
    if (!payment_term_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + payment_term_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printPaymentTerm = (payment_term_id) => {
    if (!payment_term_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?payment_term_id=" + payment_term_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createPaymentTerms = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updatePaymentTerms = (payload, payment_term_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + payment_term_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deletePaymentTerms = (payment_term_id) => {
    const DELETE_END_POINT = END_POINT + "/" + payment_term_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getPaymentTerms, getPaymentTerm, printPaymentTerm, createPaymentTerms, updatePaymentTerms, deletePaymentTerms };
